const getEmployeeId = () => {
  try {
    const storedData = localStorage.getItem('adminInfo');
    if (!storedData) return 0;
    const adminInfo = JSON.parse(storedData);
    return adminInfo?.id ;
  } catch (e) {
    console.error("Error parsing adminInfo from localStorage:", e);
    return 0;
  }
};

module.exports = getEmployeeId;
